import { IBpaState } from './bpaContext';
import { BpaActionTypes, TBpaAction } from './bpaActions';

export const bpaReducer = (state: IBpaState, action: TBpaAction): IBpaState => {
	switch (action.type) {
		case BpaActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case BpaActionTypes.CHANGE_BPA:
			return {
				...state,
				bpa: action.payload.bpa,
			};
		case BpaActionTypes.ADD_BPA_BLOCK:
			return {
				...state,
				bpa: [...state.bpa, action.payload.bpa],
			};
		case BpaActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case BpaActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
